// extracted by mini-css-extract-plugin
export default {"burger_menu":"BurgerMenu_burger_menu__02IId","hover":"BurgerMenu_hover__phrip","burger":"BurgerMenu_burger__NeY2U"};